import React, { useState } from 'react';
import LotteryFormDesigner from './LotteryFormDesigner';
import LotteryForm from './LotteryForm';
import LotteryActivityManager from './LotteryActivityManager';
import './LotteryFormExample.css';

const LotteryFormExample = () => {
  const [currentView, setCurrentView] = useState('manager'); // 'manager' | 'designer' | 'form' | 'example'
  const [savedConfig, setSavedConfig] = useState(null);

  // 保存配置
  const handleSaveConfig = (config) => {
    setSavedConfig(config);
    console.log('保存的抽奖配置:', config);
    alert('抽奖表单配置已保存！');
  };

  // 预览配置
  const handlePreviewConfig = (config) => {
    setSavedConfig(config);
    setCurrentView('form');
  };

  // 抽奖结果处理
  const handleLotteryResult = (result) => {
    console.log('抽奖结果:', result);
    
    // 这里可以发送到后端保存抽奖记录
    // 或者显示更详细的结果信息
    if (result.isWinner) {
      alert(`恭喜您获得 ${result.prize.name}！\n券码：${result.couponCode}`);
    } else {
      alert('谢谢参与！');
    }
  };

  // 示例配置
  const exampleConfig = {
    title: '新春大抽奖',
    subtitle: '转动转盘，赢取新年好礼',
    prizes: [
      { name: '特等奖', probability: 1, color: '#FFD700', icon: '🏆', coupon: 'SPECIAL_001' },
      { name: '一等奖', probability: 5, color: '#FF6B6B', icon: '🎁', coupon: 'FIRST_001' },
      { name: '二等奖', probability: 15, color: '#4ECDC4', icon: '🎁', coupon: 'SECOND_001' },
      { name: '三等奖', probability: 30, color: '#45B7D1', icon: '🎁', coupon: 'THIRD_001' },
      { name: '谢谢参与', probability: 49, color: '#96CEB4', icon: '🍀', coupon: null }
    ],
    theme: {
      primaryColor: '#FF6B6B',
      secondaryColor: '#FFE66D',
      backgroundColor: '#FFF5F5',
      textColor: '#333333'
    },
    settings: {
      allowMultipleDraws: false,
      showProbability: true,
      autoGenerateCoupon: true
    }
  };

  return (
    <div className="lottery-example">
      <div className="example-content">
        {currentView === 'manager' && (
          <LotteryActivityManager />
        )}

        {currentView === 'designer' && (
          <LotteryFormDesigner
            onSave={handleSaveConfig}
            onPreview={handlePreviewConfig}
          />
        )}

        {currentView === 'form' && savedConfig && (
          <div className="form-container">
            <div className="form-header">
              <h2>客户抽奖页面</h2>
              <p>客户可以在这里进行自助抽奖</p>
            </div>
            <LotteryForm
              formData={savedConfig}
              onResult={handleLotteryResult}
              isPreview={false}
            />
          </div>
        )}

        {currentView === 'example' && (
          <div className="example-container">
            <div className="example-header">
              <h2>示例演示</h2>
              <p>这是一个预设的抽奖表单示例</p>
            </div>
            <LotteryForm
              formData={exampleConfig}
              onResult={handleLotteryResult}
              isPreview={false}
            />
          </div>
        )}

        {currentView === 'form' && !savedConfig && (
          <div className="no-config">
            <div className="no-config-content">
              <h3>暂无配置</h3>
              <p>请先在设计器中创建并保存抽奖配置</p>
              <button onClick={() => setCurrentView('designer')}>
                前往设计器
              </button>
            </div>
          </div>
        )}
      </div>

    </div>
  );
};

export default LotteryFormExample;
